import axios from 'axios';

const CMS_BASE_URL = 'http://workshopcms.usoplanet.co';
export const RES_BASE_URL = 'https://www.chumsda.org/cmsimg/';
export const PROD_BASE_URL = "http://sdaweb.usoplanet.com";

export function getCategories() {
  const request = axios.get(CMS_BASE_URL+'/getCategories');
  return request;
}

export function getAvailableMonthByCategory(categoryId) {
  const request = axios.get(CMS_BASE_URL + '/getAvailableMonthByCategory/' + categoryId);
  return request;
}

export function getCoursesByCategoryAndMonth(categoryId, month, year) {
  const request = axios.get(CMS_BASE_URL + '/getCoursesByCategoryAndMonth/' + categoryId + "/" + month + "/" + year);
  return request;
}

export function getInstructorByCourseName(courseName) {
  const request = axios.post(CMS_BASE_URL + '/getInstructorByCourseName', {
    "courseName": courseName
  });
  return request;
}

export function searchCourse(instructorId, month, year, courseName) {

    const request = axios.post(CMS_BASE_URL + '/searchCourse', {
      "instructorId": instructorId,
      "month": month,
      "year": year,
      "courseName": courseName
    });
    return request;

}

export function enrollCourse(name, email, phone, courseId) {

    const request = axios.post(CMS_BASE_URL + '/enrollCourse', {
      "name": name,
      "email": email,
      "courseId": courseId,
      "phone": phone
    });
    return request;
}